import React from 'react'
import MaterialSymbol from '../material-symbol'

const ExpandMore = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="expand_more" {...props} />
))

ExpandMore.displayName = 'ExpandMore'

export default ExpandMore
